import { navLinks, siteContact, trendCategories, trendingTopics } from '@/mocks/home';

export default function SiteFooter() {
  const year = new Date().getFullYear();
  const topTopics = trendingTopics.slice(0, 5);

  const jump = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-label text-sm font-bold text-background-50">
                51
              </span>
              <span className="font-heading text-lg font-bold text-background-50">吃瓜</span>
            </div>
            <p className="mt-4 max-w-sm font-body text-sm leading-relaxed text-background-100/70">
              事件补课专区：前情回顾、事件全貌、背景资料、反转记录、后续进度一次补全，让你吃瓜不掉队。
            </p>
            <a
              href={`mailto:${siteContact.email}`}
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap font-label text-sm text-background-100 transition-colors hover:text-accent-300 cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-line" />
              </span>
              {siteContact.email}
            </a>
          </div>

          <nav className="lg:col-span-3" aria-label="页脚导航">
            <h4 className="font-heading text-sm font-bold text-background-50">补课目录</h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      jump(link.id);
                    }}
                    className="whitespace-nowrap font-body text-sm text-background-100/70 transition-colors hover:text-accent-300 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="lg:col-span-4">
            <h4 className="font-heading text-sm font-bold text-background-50">近期热门吃瓜</h4>
            <ul className="mt-4 space-y-2.5">
              {topTopics.map((topic) => (
                <li key={topic.title}>
                  <a
                    href="#trending"
                    onClick={(e) => {
                      e.preventDefault();
                      jump('trending');
                    }}
                    className="flex items-start gap-2 font-body text-sm text-background-100/70 transition-colors hover:text-accent-300 cursor-pointer"
                  >
                    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent-400" />
                    <span>{topic.title}</span>
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-5 flex flex-wrap gap-2">
              {trendCategories.slice(1).map((c) => (
                <span
                  key={c}
                  className="inline-flex items-center rounded-full border border-background-50/20 px-2.5 py-1 font-label text-[11px] text-background-100/70"
                >
                  {c}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-body text-xs text-background-100/60">
            © {year} 51.吃瓜 · 事件补课专区 · 内容仅供信息梳理与讨论参考
          </p>
          <p className="font-body text-xs text-background-100/60">
            站内案例为示例演示，人物与情节均经过处理。
          </p>
        </div>
      </div>
    </footer>
  );
}